import { getFilePath } from '.';
import { AUDIO_STATUS } from '../pages/title/AdvancedAudio';

const INVALID_PREFIX = `${AUDIO_STATUS.INVALID}: `;

const getLabelForAsset = (asset) => {
    if (asset.assettype === 'image') return 'Cover image';
    const filename = getFilePath(asset.filename);
    if (asset.name && filename && asset.name !== filename) return `${asset.name} (${filename})`;
    return asset.name || filename || 'Unnamed file';
};

// The cover is replaced on the Metadata page and audio on the Audio page; other files have no page to fix them.
const getFixPageForAsset = (asset) => {
    if (asset.assettype === 'image') return 'metadata';
    if (asset.assettype === 'audio') return 'assets';
    return null;
};

const getReasonForAsset = (asset) => {
    if (asset.status && asset.status.startsWith(INVALID_PREFIX)) return asset.status.slice(INVALID_PREFIX.length);
    if (asset.status && asset.status.includes(AUDIO_STATUS.INVALID)) return 'This file failed validation.';
    return 'This file is not placed in a section of the audiobook.';
};

// An audio file without a group should not be possible via the UI, but a downstream bug allows it; it blocks submit too.
const isAssetBlockingSubmit = (asset) =>
    (asset.status && asset.status.includes(AUDIO_STATUS.INVALID)) || (asset.assettype === 'audio' && !asset.group);

export const getValidationErrorsForAssets = (assets = []) =>
    (assets || []).filter(isAssetBlockingSubmit).map((asset) => ({
        id: asset.id,
        label: getLabelForAsset(asset),
        reason: getReasonForAsset(asset),
        page: getFixPageForAsset(asset)
    }));
